import { render, staticRenderFns } from "./view-information.vue?vue&type=template&id=630ab7b2&scoped=true&"
import script from "./view-information.vue?vue&type=script&lang=js&"
export * from "./view-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630ab7b2",
  null
  
)

export default component.exports